import HomeTransactions from 'components/activity/transactions/main/containers/HomeTransactions';
import Transactions from 'components/activity/transactions/main/containers/TransactionsContainer';
import PendingTransactionsList from '../../activity/transactions/main/presentational/PendingTransactionsList';

const activityRoutes = [
    { path: '', component: HomeTransactions, pageTitle: 'Home' },
    { path: '/activity/transactions', component: Transactions, pageTitle: 'Transactions' },
    {
        path: '/activity/pending',
        component: PendingTransactionsList,
        pageTitle: 'Pending Transactions',
    },
];

export default activityRoutes;
